import { IWorkDay, IWorkingSchedule, WorkingHours } from '../../types/work-week'
import { ShortestLeaveIntervalEnum } from '../../types/leave-policy'
import { IQuotaAmount } from '../../types/leave-policy'
import { computeDaysAndHoursForLeaveDays } from '../../functions/get-days-or-hours'
import { ILeaveDayDetails } from '../../types/leave-request'
import { getLeaveHoursForCurrentAndNextPeriod } from '../../functions/leave-duration'

interface IGetRequestedDaysAmount {
  shortestLeaveInterval: ShortestLeaveIntervalEnum
  leaveDaysWithWorkingHours: IWorkDay[] | ILeaveDayDetails[] // difference is that in IWorkDay is Date object, and in ILeaveDayDetails is datestring
  nextYearStart: Date
  period: 'current' | 'next'
  userWorkingHours: WorkingHours | IWorkingSchedule
}

export const getRequestedDaysAmount = ({
  shortestLeaveInterval,
  leaveDaysWithWorkingHours,
  nextYearStart,
  period,
  userWorkingHours,
}: IGetRequestedDaysAmount): IQuotaAmount => {
  const requestedDaysForPeriods = getLeaveHoursForCurrentAndNextPeriod(leaveDaysWithWorkingHours, nextYearStart)

  const requestedHours = requestedDaysForPeriods[period].usedHours
  const requestedDaysForPeriod = requestedDaysForPeriods[period].leaves

  const resultRequestedDays = computeDaysAndHoursForLeaveDays(
    requestedDaysForPeriod,
    userWorkingHours,
    shortestLeaveInterval
  )

  const fullDays = requestedDaysForPeriod.filter(workday => workday.leaveHours === workday.workingHoursInDay).length
  const hoursWithMinutes = requestedDaysForPeriod.filter(workday => workday.leaveHours !== workday.workingHoursInDay)
  const partialDays = hoursWithMinutes.reduce((acc, workday) => acc + workday.leaveHours / workday.workingHoursInDay, 0)

  return {
    raw: { 
      days: fullDays + partialDays,
      hours: requestedHours,
    },
    days: resultRequestedDays.days,
    hours: resultRequestedDays.hours,
    minutes: resultRequestedDays.minutes,
    isNegative: resultRequestedDays.isNegative,
  }
}